<template lang="html">
    <button type="button" class="btn-close modal-default-button" @click="close">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 13.8 14" style="enable-background:new 0 0 13.8 14;" xml:space="preserve">
            <path d="M11.1,10.5L7.5,7l3.5-3.5c0.2-0.2,0.2-0.5,0-0.7c-0.2-0.2-0.5-0.2-0.7,0L6.8,6.3L3.3,2.7c-0.2-0.2-0.5-0.2-0.7,0
                c-0.2,0.2-0.2,0.5,0,0.7L6.1,7l-3.5,3.5c-0.2,0.2-0.2,0.5,0,0.7c0.2,0.2,0.5,0.2,0.7,0l3.5-3.5l3.5,3.5c0.2,0.2,0.5,0.2,0.7,0
                C11.3,11,11.3,10.7,11.1,10.5z"/>
        </svg>
    </button>
</template>

<script>
    export default {
        name: 'closeButton',
        components: {
        },
        methods : {
            close(){
                this.$emit('closeModal');
            }
        }
    }
</script>

